const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'dotcms_utm';

export function captureUtms() {
    if (typeof window === 'undefined') return;
    try {
        if (sessionStorage.getItem(STORAGE_KEY)) return;

        const params = new URLSearchParams(window.location.search);
        const utms = {};
        for (const key of UTM_KEYS) {
            const value = params.get(key);
            if (value) utms[key] = value;
        }
        if (Object.keys(utms).length > 0) {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
        }
    } catch {
        // sessionStorage may be unavailable (privacy mode, sandboxed iframe, etc.) — silently skip
    }
}

export function readUtms() {
    if (typeof window === 'undefined') return {};
    try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (!stored) return {};
        const parsed = JSON.parse(stored);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
}

export { UTM_KEYS };
